import {
  Directive,
  Input,
  ElementRef
} from '@angular/core';

import { Subscription } from "rxjs";

@Directive(
    {
    selector: '[setFocus]',
    standalone: false
}
)

export class SetFocusDirective {
  @Input('setFocus') id: string;

  constructor(public el:ElementRef) {

  }

  getElementRef(): ElementRef {
    return this.el;
  }

  setElementFocus(): void {
    let natElement = this.el.nativeElement;

    //timeout required to set focus
    setTimeout(() => {
      natElement.focus();
    }, 1);

  }
}